var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(
      _vm.selected_report?.report_code !== _vm.current_report_code &&
      _vm.selected_report?.report_url !== _vm.current_report_code
    )?_c('b-overlay',{attrs:{"show":"","no-wrap":""}}):[(_vm.selected_report?.story_board)?_c('StoryBoardViewer'):_c('StandardIndex')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }